import { regionsForHolidays, STORAGE_KEY_PICKED_RANGE } from "../Config";
import { getHolidayByDate, Holiday, isSunOrHoliday } from "feiertagejs";
import { DateTime } from "@easepick/bundle";
import { getHolidays } from "../../../Utils/Holidays";
import { addTooltipDayOverlay } from "../../../EasePick/Utils/Tooltip";

export const addBlackoutTooltip = (view: string, target: HTMLElement, date: DateTime) => {
    if (view === "CalendarDay") {
        if (date && regionsForHolidays.find((r) => isSunOrHoliday(date, r))) {
            const grid = target.parentElement;
            const holiday = getHolidayByDate(date, "ALL") as Holiday;
            if (holiday && grid && view === "CalendarDay") {
                const name = holiday.translate();
                if (name) {
                    addTooltipDayOverlay(target, name, grid);
                }
            }
        }
    }
};
export const today = new DateTime();
export const inAYear = today.clone().add(365);
const fullYear = today.format("YYYY");
export const seasonStart = new DateTime(`${fullYear}-04-01`);
export const seasonEnd = new DateTime(`${fullYear}-10-31`);
if (seasonEnd.isBefore(today)) {
    seasonStart.setFullYear(+fullYear + 1);
    seasonEnd.setFullYear(+fullYear + 1);
}

const getClosedMonths = (days: number = 400): DateTime[] => {
    return [...Array(days).keys()]
        .map((i) => {
            return today.clone().add(i);
        })
        .filter((d) => {
            return d.isBefore(seasonStart) || d.isAfter(seasonEnd);
        });
};

export const holidayBlackoutsAllYear = getHolidays(regionsForHolidays, 400, today);
export const holidayBlackouts = [...holidayBlackoutsAllYear, ...getClosedMonths(400)];

const pickedRange: { start: number; end: number } = JSON.parse(localStorage.getItem(STORAGE_KEY_PICKED_RANGE)) || {
    start: 0,
    end: 0
};
if (pickedRange) {
    localStorage.removeItem(STORAGE_KEY_PICKED_RANGE);
}
export { pickedRange };
